import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import AdminNavigation from '../../components/ui/AdminNavigation';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import PendingApplications from './components/PendingApplications';
import ActiveVendors from './components/ActiveVendors';
import VendorAnalytics from './components/VendorAnalytics';

const VendorManagement = () => {
  const [activeTab, setActiveTab] = useState('pending');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const tabs = [
    { id: 'pending', label: 'Pending Applications', icon: 'Clock', count: 12 },
    { id: 'active', label: 'Active Vendors', icon: 'Building2', count: 156 },
    { id: 'analytics', label: 'Vendor Analytics', icon: 'BarChart3', count: null }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'pending':
        return <PendingApplications />;
      case 'active':
        return <ActiveVendors />;
      case 'analytics':
        return <VendorAnalytics />;
      default:
        return <PendingApplications />;
    }
  };

  return (
    <>
      <Helmet>
        <title>Vendor Management - Lalay Fashion Admin</title>
        <meta 
          name="description" 
          content="Manage vendor applications, active partnerships, and performance analytics for Lalay Fashion marketplace." 
        />
      </Helmet>

      <div className="min-h-screen bg-background">
        <AdminNavigation 
          isCollapsed={sidebarCollapsed}
          onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        />
        
        <main 
          className={`transition-all duration-300 ${
            sidebarCollapsed ? 'ml-16' : 'ml-64'
          } p-6 lg:p-8`}
        >
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div>
                <h1 className="text-3xl font-heading font-bold text-foreground">
                  Vendor Management
                </h1>
                <p className="text-muted-foreground mt-2">
                  Oversee vendor relationships, applications, and marketplace performance
                </p>
              </div>
              
              <div className="flex flex-wrap items-center gap-3">
                <Button variant="outline" iconName="Download" iconPosition="left">
                  Export Data
                </Button>
                <Button variant="default" iconName="Plus" iconPosition="left">
                  Invite Vendor
                </Button>
              </div>
            </div>
          </div>

          {/* Tabs Navigation */}
          <div className="bg-card rounded-xl border border-border mb-6 overflow-hidden">
            <div className="flex flex-wrap border-b border-border">
              {tabs?.map((tab) => (
                <button
                  key={tab?.id}
                  onClick={() => setActiveTab(tab?.id)}
                  className={`flex items-center gap-3 px-6 py-4 font-medium transition-colors relative ${
                    activeTab === tab?.id
                      ? 'text-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                  }`}
                >
                  <Icon name={tab?.icon} size={20} />
                  <span>{tab?.label}</span>
                  {tab?.count !== null && (
                    <span className={`px-2.5 py-0.5 rounded-full text-xs font-semibold ${
                      activeTab === tab?.id
                        ? 'bg-primary text-primary-foreground'
                        : 'bg-muted text-muted-foreground'
                    }`}>
                      {tab?.count}
                    </span>
                  )}
                  {activeTab === tab?.id && (
                    <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary" />
                  )}
                </button>
              ))}
            </div>
          </div>

          {/* Tab Content */}
          <div className="animate-fadeIn">
            {renderTabContent()}
          </div>
        </main>
      </div>
    </>
  );
};

export default VendorManagement;